const PHRASES = getPhrases();
const DEFAULT_LANG = 'en';

let currentLang = DEFAULT_LANG;

export default (phrase) => PHRASES[currentLang][phrase] || phrase;

export function setLanguage(lang) {
  currentLang = lang in PHRASES ? lang : DEFAULT_LANG;
}

function getPhrases() {
  return {
    'en': {}, // English translations not needed but should be a empty object
    'sv': {
      'Machine': 'Maskin',
      'Kg/ day': 'Kg/ dag',
      'Labour cost EUR/ hour': 'Arbetskostnad EUR/ timme',
      'Social fees, (percentage of labour cost)': 'Sociala avgifter, (procent på arbetskostnad)',
      'Days per week': 'Antal dagar/ vecka',
      'Days per month': 'Antal dagar/ månad',
      'Investment': 'Investering',
      'List Price': 'Listpris',
      'Money saved EUR': 'Kostnadsbesparing EUR',
      'After the first quarter': 'Efter första kvartalet',
      'After the first year': 'Efter första året',
      'Time saved': 'Sparad tid',
      'Hours/ week': 'Timmar/ vecka',
      'Hours/ month': 'Timmar/ månad',
      'Payback-time': 'Återbetalningstid',
      'weeks': 'veckor',
      'days': 'dagar',
      'months': 'månader',
      'Return of investment': 'Avkastning på investering (ROI)',
      'Working days per year': 'Arbetsdagar per år',
      'Working days per week': 'arbetsdagar per vecka',
      'You\'ll save': 'Du sparar',
      'by the first': 'de första',
      '12 months': '12 månaderna',
      'Error, can\'t find product.': 'Fel, kan inte hitta produkten',
      'Something went wrong. Please try again later!': 'Något gick fel, vänligen försök senare!',
      'Vegetable - Cutting tool': 'Grönsak - Skärverktyg',
      'Add vegetable': 'Lägg till grönsak',
    },
    'pl': {
      'Machine': 'Maszyna',
      'Kg/ day': 'Kg/ dzień',
      'Labour cost EUR/ hour': 'Koszt pracy EUR/h',
      'Social fees, (percentage of labour cost)': 'Dodatki socjalne, (jako procent kosztu pracy)',
      'Days per week': 'Dni roboczych w tygodniu',
      'Days per month': 'Dni roboczych w miesiący',
      'Investment': 'Wysokość inwestycji',
      'List Price': 'Cena katalogowa',
      'Money saved EUR': 'Kwota oszczędności w EUR',
      'After the first quarter': 'Po pierwszym kwartale',
      'After the first year': 'Po pierwszym roku',
      'Time saved': 'Zaoszczędzony czas',
      'Hours/ week': 'Godzin/tydzień',
      'Hours/ month': 'Godzin/miesiąc',
      'Payback-time': 'Czas zwrotu inwestycji',
      'weeks': 'tydzień',
      'days': 'Dni',
      'months': 'Miesiące',
      'Return of investment': 'Zwrot na inwestycji',
      'Working days per year': 'Dni robocze w roku',
      'Working days per week': 'Dni robocze w tygodniu',
      'You\'ll save': 'Zaoszczędzisz',
      'by the first': 'Przed pierwszym',
      '12 months': '12 miesięcy',
      'Error, can\'t find product.': 'Błąd, produkt nie znaleziony',
      'Something went wrong. Please try again later!': 'Coś poszło nie tak. Proszę spróbować ponownie za chwilę !',
      'Vegetable - Cutting tool': 'Warzywa - Naczynia tnące',
      'Add vegetable': 'Dodaj warzywo',
    },
    'ru': {
      'Machine': 'Машину',
      'Kg/ day': 'кг/смену',
      'Labour cost EUR/ hour': 'Стоимость труда (Евро/час)',
      'Social fees, (percentage of labour cost)': 'Социальные выплаты (% от стоимости труда в час)',
      'Days per week': 'Рабочих дней в неделю',
      'Days per month': 'Рабочих дней в месяц',
      'Investment': 'Инвестиции',
      'List Price': 'Рекомендованная розничная цена',
      'Money saved EUR': 'Сэкономленные деньги (Евро)',
      'After the first quarter': 'По итогам первого квартала',
      'After the first year': 'По итогам первого года',
      'Time saved': 'Сэкономленное время',
      'Hours/ week': 'часов в неделю',
      'Hours/ month': 'часов в месяц',
      'Payback-time': 'Срок полной окупаемости',
      'weeks': 'недели',
      'days': 'дни',
      'months': 'месяцы',
      'Return of investment': 'Возврат инвестиций',
      'Working days per year': 'Рабочих дней в году',
      'Working days per week': 'Рабочих дней в неделю',
      'You\'ll save': 'Вы сэкономите',
      'by the first': 'по первому',
      '12 months': '12 месяцев',
      'Error, can\'t find product.': 'Ошибка, не удается найти продукт.',
      'Something went wrong. Please try again later!': ' Что-то пошло не так. Пожалуйста, повторите попытку позже',
      'Vegetable - Cutting tool': 'Продукт - Режущий диск',
      'Add vegetable': 'Добавить овощи',
    },
    'de': {
      'Machine': 'Maschine',
      'Kg/ day': 'kg/Tag',
      'Labour cost EUR/ hour': 'Personalkosten EUR/Tag',
      'Social fees, (percentage of labour cost)': 'Sozialabgaben, (prozentual zu Personalkosten)',
      'Days per week': 'Tage pro Woche',
      'Days per month': 'Tage pro Monat',
      'Investment': 'Investitionssumme',
      'List Price': 'Listenpreis',
      'Money saved EUR': 'Gespart EUR',
      'After the first quarter': 'nach dem ersten Quartal',
      'After the first year': 'Nach einem Jahr',
      'Time saved': 'Zeit gespart',
      'Hours/ week': 'Stunden / Woche',
      'Hours/ month': 'Stunden / Monat',
      'Payback-time': 'Amortisationszeit',
      'weeks': 'Wochen',
      'days': 'Tage',
      'months': 'Monate',
      'Return of investment': 'Investitionsgewinn',
      'Working days per year': 'Arbeitstage pro Jahr',
      'Working days per week': 'Arbeitstage pro Woche',
      'You\'ll save': 'Sie sparen',
      'by the first': 'in den ersten',
      '12 months': '12 Monaten',
      'Error, can\'t find product.': 'Das Produkt konnte nicht gefunden werden.',
      'Something went wrong. Please try again later!': 'Etwas lief schief. Bitte versuchen Sie es später noch einmal!',
      'Vegetable - Cutting tool': 'Gemüse - Schneidwerkzeug',
      'Add vegetable': 'Gemüse hinzufügen',
    },
  };
}
